import React from 'react';

import styled from 'styled-components';

import { INutritionInfo } from '@rbi-ctg/menu';

import { Table, TableData, TableRow, TableTitle } from '../styled/table';

import { SanityNutritionItemGroup } from './types';

const ListItem = styled(TableRow)`
  text-indent: 1rem;
`;

const ListItemData = styled(TableData)``;

type NutritionItemGroupProps = {
  nutritionInfo: INutritionInfo;
  nutritionItemGroups: { items: SanityNutritionItemGroup[] }[];
  roundNutritionValue: (val: number) => number;
};

export const NutritionItemGroup: React.FC<NutritionItemGroupProps> = ({
  nutritionInfo,
  nutritionItemGroups,
  roundNutritionValue,
}) => {
  const nutritionItemGroupData = nutritionItemGroups?.[0];

  return (
    <div data-testid="nutrition-item-group">
      {nutritionItemGroupData?.items?.map(groupItem => {
        const mainItemValue =
          nutritionInfo[groupItem?.mainItem?.nutritionKey as keyof INutritionInfo] ?? 0;

        const roundedMainItemValue = roundNutritionValue(mainItemValue);

        const mainItemOmitUnitFromValue = groupItem?.mainItem?.omitUnitFromValue;
        const mainItemUnit = groupItem?.mainItem?.unit?.locale ?? '';

        let mainItemNutritionValue;
        if (mainItemOmitUnitFromValue) {
          mainItemNutritionValue = `${roundedMainItemValue}`;
        } else {
          mainItemNutritionValue = `${roundedMainItemValue}${mainItemUnit}`;
        }

        return (
          <Table key={groupItem?._key}>
            <TableRow>
              <TableTitle>{groupItem?.mainItem?.name?.locale}</TableTitle>
            </TableRow>
            <TableRow data-testid="nutrition-item-group-main-item">
              <TableData>{groupItem?.mainItem?.name?.locale}</TableData>
              <TableData data-testid="nutrition-item-group-main-item-value">
                {mainItemNutritionValue}
              </TableData>
            </TableRow>
            {groupItem?.lineItems?.map(listItem => {
              const listItemValue =
                nutritionInfo[listItem?.nutritionKey as keyof INutritionInfo] ?? 0;

              const listItemOmitUnitFromValue = listItem?.omitUnitFromValue;
              const listItemUnit = listItem?.unit?.locale ?? '';

              const roundedListItemValue = roundNutritionValue(listItemValue);

              let listItemNutritionValue;
              if (listItemOmitUnitFromValue) {
                listItemNutritionValue = `${roundedListItemValue}`;
              } else {
                listItemNutritionValue = `${roundedListItemValue}${listItemUnit}`;
              }

              return (
                <ListItem key={listItem?.nutritionKey} data-testid="nutrition-item-group-line-item">
                  <ListItemData>{listItem?.name?.locale}</ListItemData>
                  <ListItemData data-testid="nutrition-item-group-line-item-value">
                    {listItemNutritionValue}
                  </ListItemData>
                </ListItem>
              );
            })}
          </Table>
        );
      })}
    </div>
  );
};
